import { selectAssignment } from '@redux/experiments/selectors/index';
import type { StorefrontsNetworkAssignment } from 'types/experiments';
import type { State } from 'types/redux';

const isEligibleForStorefrontsNetwork = (state: State) => {
	const isPaidVendor = state.vendor.vendor?.isPaid;
	const isVenue = state.vendor.vendor?.categoryCode === 'REC';
	const member = state.membership.member;

	return (
		!!isVenue && !!isPaidVendor && !!member?.first_name && !!member?.last_name
	);
};

export const storefrontsNetworkAssignmentSelector = (state: State) => {
	if (!isEligibleForStorefrontsNetwork(state)) return null;

	return selectAssignment(state, [
		'storefrontsNetwork',
	]) as StorefrontsNetworkAssignment;
};
